var PUBLIC_URL = process.env.PUBLIC_URL || '';
export default function publicUrl(path) {
  return "".concat(PUBLIC_URL).concat(path);
}